<template>
  <base-layout>
    <div class="end-game" v-if="winner">
      <div class="container-fluid">
        <div class="text-center">
          <p v-html="$t('endGame')"></p>
          <div class="winner">
            <dx-player
              :avatar="winner.avatar"
              :points="winner.points"
              :mediator="true"
              />
          </div>
          <router-link :to="{ name: 'newGame' }">
            <dx-button success large>{{ $t('newGame') }}</dx-button>
          </router-link>
        </div>
      </div>
    </div>
    <dx-fireworks></dx-fireworks>
  </base-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxButton,
  DxPlayer,
  DxFireworks
} from '../components'
export default {
  name: 'end-game',
  components: {
    BaseLayout,
    DxButton,
    DxPlayer,
    DxFireworks
  },
  computed: {
    ...mapGetters({
      winner: 'getWinner'
    })
  },
  created () {
    if (!this.winner) {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EndGame.vue